import React, {useState, useEffect} from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  SlTabGroup,
  SlTab,
  SlTabPanel,
} from "@shoelace-style/shoelace/dist/react";
import PlanSummary from "./PlanSummary";
import MonthwisePlan from "./MonthwisePlan";
import PenetrationVsNewspaper from "./PenetrationVsNewspaper";
import Conversion from "./Conversion";
import SalesTasks from "./SalesTasks";
import NationalPlanning from "./NationalPlanning";
import Buildup from './BuildupSheet'

function PlanningReports() {
  const { tab } = useParams();
  const navigate = useNavigate();
  const [currentTab, setCurrentTab] = useState(tab || "planning");

  useEffect(() => {
    if (tab && tab !== currentTab) setCurrentTab(tab);
  }, [tab]);

  const handleTabChange = (e) => {
    const name = e.detail.name;
    setCurrentTab(name);
    navigate(`/home/brandreports/${name}`, { replace: true });
  };

  return (
    <>
      <h5>Yearly Reports</h5>
      <SlTabGroup onSlTabShow={handleTabChange}>
        <SlTab slot="nav" panel="planning" active={currentTab === 'planning'}>Planning</SlTab>
        <SlTab slot="nav" panel="buildup" active={currentTab === 'buildup'}>BuildUp</SlTab>
        <SlTab slot="nav" panel="plan_summary" active={currentTab === 'plan_summary'}>Plan Summary</SlTab>
        <SlTab slot="nav" panel="monthwise_plan" active={currentTab === 'monthwise_plan'}>Monthwise Plan</SlTab>
        <SlTab slot="nav" panel="penetration" active={currentTab === 'penetration'}>Penetration vs Eenadu</SlTab>
        <SlTab slot="nav" panel="conversion" active={currentTab === 'conversion'}>Conversion Progress</SlTab>
        <SlTab slot="nav" panel="keysalestasks" active={currentTab === 'keysalestasks'}>Key Sales Takes</SlTab>
        <SlTabPanel name="planning">
          {currentTab === 'planning' && <NationalPlanning />}
        </SlTabPanel>
        <SlTabPanel name="buildup">
          {currentTab === 'buildup' && <Buildup />}
        </SlTabPanel>
        <SlTabPanel name="plan_summary">
            {currentTab === 'plan_summary' && <PlanSummary />}
        </SlTabPanel>
        <SlTabPanel name="monthwise_plan">
          {currentTab === 'monthwise_plan' && <MonthwisePlan />}
          </SlTabPanel>
        <SlTabPanel name="penetration">
          {currentTab === 'penetration' && <PenetrationVsNewspaper />}
          </SlTabPanel>
          <SlTabPanel name="conversion">
            {currentTab === 'conversion' && <Conversion />}
          </SlTabPanel>
        <SlTabPanel name="keysalestasks">
          {currentTab === 'keysalestasks' && <SalesTasks/>}
        </SlTabPanel>
      </SlTabGroup>
    </>
  );
}

export default PlanningReports;
